import * as types from '@/store/mutation-types'

export default {
    [types.SET_ALL_LOCATIONS](state, locations) {
        state.allLocations = locations
    },
    [types.SET_SEARCHED_LOCATIONS](state, locations) {
        state.searchedLocations = locations
    },
    [types.SET_LOCATION](state, location) {
        state.location = location
    },
    [types.SET_LOCATION_ADDRESS](state, location) {
        state.locationAddress = location
    },
    [types.SET_LOCATION_GROUPS](state, locationGroups) {
        state.allLocationGroups = locationGroups
    },

    [types.SET_LOCATION_GROUP_WITH_LOCATION](state, locationGroup) {
        state.locationGroupWithLocations = locationGroup
    },
    [types.SET_BUSINESS_USERS](state, users) {
        state.users = users
    }
}
